import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { AUTO_DEBIT_CANCELLATION_APIS } from "../constants/AutoDebitCancellationModal.constants";

export const useAutoDebitCancellationReasons = () =>
  useCustomQuery({
    url: AUTO_DEBIT_CANCELLATION_APIS.reasons,
    queryKey: [AUTO_DEBIT_CANCELLATION_APIS.reasons],
  });
